import { FC } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import { ROUTES } from './lib/constants'
import { AuthProvider, AuthService } from './auth'
import { Callback } from './auth/Callback'
import { PasswordGate } from './passwordGate/PasswordGate'
import { BackOffice } from './backoffice/Main'
import { CodeClaimPage } from './CodeClaimPage'
import { ScanPage } from './ScanPage'
import { AdminLoginPage } from './AdminLoginPage'
import { RedeemPage } from './RedeemPage'
import WebsiteClaimIndexPage from './WebsiteClaimPage'
import { useAppMonitor } from 'lib/hooks/useAppMonitor'
import { useTrackEvents } from 'lib/hooks/useTrackEvents'

const Routes = () => {
  useAppMonitor()
  useTrackEvents()

  return (
    <Switch>
      {/* Render redirects */}
      <Redirect from={ROUTES.renderToken} to={ROUTES.token} />

      {/* Backoffice */}
      <Route exact path={ROUTES.callback} component={Callback} />
      <Route
        exact
        path={ROUTES.adminLogin.path}
        render={() => (
          <PasswordGate>
            <AdminLoginPage />
          </PasswordGate>
        )}
      />
      <Route
        path={ROUTES.admin}
        render={() => (
          <PasswordGate>
            <BackOffice />
          </PasswordGate>
        )}
      />

      {/* dApp / claims */}
      <Route path={ROUTES.codeClaimWeb3PageHash} component={CodeClaimPage} />
      <Route path={ROUTES.codeClaimPageHash} component={CodeClaimPage} />
      <Route path={ROUTES.codeClaimPage} component={CodeClaimPage} />
      <Route path={ROUTES.redeem} component={RedeemPage} />
      <Route path={ROUTES.websiteClaim.home.path} component={WebsiteClaimIndexPage} />

      {/* Home */}
      <Route path={ROUTES.home} component={ScanPage} />
    </Switch>
  )
}

type AppProps = { auth: AuthService }

const App: FC<AppProps> = ({ auth }) => (
  <AuthProvider value={auth}>
    <Router>
      <Routes />
    </Router>
  </AuthProvider>
)

export default App
